/**
 * 個人の「要件定義」系 / 「開発」系を見分ける主題色（浅緑 / 橙黄）。
 *
 * 当月pt 内訳カード（`MemberPtBreakdownCard`）の 2 本のバーで導入した色で、**同じ画面の中で
 * 要件定義と開発を見分ける軸**として使う。マイページ / メンバー詳細の「担当要件定義案件一覧」と
 * 「担当開発案件一覧」の見出しも同じ 2 色で塗り、ページ上部の内訳バーと下の 2 つの一覧が
 * 同じ色の対応で読めるようにする。色がカードごとにずれると、同じ画面に 2 組の凡例が
 * できてしまう。
 *
 * KPI 画面の「開発pt (MTD)」内訳が使う `REQUIREMENT_COLOR` / `DEVELOP_COLOR`（全体 / チーム単位の
 * 水色系）とは別軸で、こちらは**個人の画面専用**。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 個人画面で要件定義系（浅緑）と開発系（橙黄）を見分ける主題色の定義。当月pt 内訳バーと担当案件一覧の見出しで共有する
 * @graph-connects none
 */

/** 要件定義系の主題色（浅い緑）。 @graph-connects none */
export const REQUIREMENT_BAR_COLOR = '#86D9A4';

/** 開発系の主題色（橙黄）。 @graph-connects none */
export const DEVELOP_BAR_COLOR = '#F0A93C';
